import { Card, CardContent } from "@/components/ui/card";
import { Activity, GitBranch, Users, ToggleLeft, Star } from "lucide-react";

interface VersionMetricsSummaryProps {
  summary: {
    totalVersions: number;
    totalKeyChanges: number;
    totalCustomerChanges: number;
    activationChanges: number;
    milestones: number;
  };
}

export const VersionMetricsSummary = ({ summary }: VersionMetricsSummaryProps) => {
  const metrics = [
    {
      label: "Total Versions",
      value: summary.totalVersions,
      icon: GitBranch,
      color: "text-primary"
    },
    {
      label: "Key Changes",
      value: summary.totalKeyChanges,
      icon: Activity,
      color: "text-chart-2"
    },
    {
      label: "Customer Changes",
      value: summary.totalCustomerChanges,
      icon: Users,
      color: "text-chart-5"
    },
    {
      label: "Activation Changes",
      value: summary.activationChanges,
      icon: ToggleLeft,
      color: "text-chart-3"
    },
    {
      label: "Milestones",
      value: summary.milestones,
      icon: Star,
      color: "text-chart-4"
    }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
      {metrics.map((metric) => (
        <Card key={metric.label} className="border-border">
          <CardContent className="pt-4">
            <div className="flex items-center gap-2 mb-2">
              <metric.icon className={`h-4 w-4 ${metric.color}`} />
              <div className={`text-2xl font-bold ${metric.color}`}>
                {metric.value}
              </div>
            </div>
            <p className="text-xs text-muted-foreground">{metric.label}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
